import type { ServiceCatalogCategory } from "@/types";
import { Box, Container } from "@mui/material";
import { ComponentHeader, ServicesGrid } from "@/components/ui";
import { PAGE_COPY } from "@/constants/pages";

export const Services = ({ categories }: { categories: ServiceCatalogCategory[] }) => {
  return (
    <Container maxWidth="lg">
      <Box>
        <ComponentHeader
          title={PAGE_COPY.sections.services.title}
          subTitle={PAGE_COPY.sections.services.subTitle}
          component="h2"
        />
        <ServicesGrid categories={categories} />
      </Box>
    </Container>
  );
};
